/* src/app/expenses/presenters/expense-receipt-view-presenter/expense-receipt-view-presenter.component.scss */
/*# sourceMappingURL=expense-receipt-view-presenter.component.css.map */
